
export default {
    props: {
        order: {
            required: true,
            default: {},
            type: Object
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        }
    },
    computed: {
        productsOrder() {
            return this.order.products
        },
        productsTotalPrice() {
            return this.order.products.reduce((partialSum, a) => {return partialSum + this.price(a).total}, 0)
        },
        isCancelled() {
            return this.order.orderHistoryType === 'cancelled'
        }
    },
    methods: {
        getDate(appointmentDate) {
            return new Date(appointmentDate).toLocaleDateString("no-NO", { year: 'numeric', month: 'long', day: 'numeric' })
        },
        getTime(appointmentDate) {
            return new Date(appointmentDate).toLocaleTimeString("no-NO", { hour: "2-digit", minute: "2-digit" })
        },
        calculateAndGetVat(totalPrice) {
            return (((totalPrice / 1.25) - totalPrice) * -1).toFixed(2)
        },
        // redirectProduct() {
        //     this.$emit('close-profile')
        //     this.layout == 'portal' ? window.open(`${process.env.VUE_APP_FIXIT_NO_URL}/frisor/${this.order.urlSafeSiteName}/${this.order.siteId}`, '_self') : this.$router.push(`/about/${this.order.urlSafeSiteName}/${this.order.siteId}`)
        // },
        // redirectSalon() {
        //     this.layout == 'portal' ? window.open(`${process.env.VUE_APP_FIXIT_NO_URL}/frisor/${this.order.urlSafeSiteName}/${this.order.siteId}`, '_self') : this.$router.push(`/about/${this.order.urlSafeSiteName}/${this.order.siteId}`)
        // },
        discount(product) {
            let lowestDiscountPrice = Math.min(product.discounts.map(x => x.discountPrice))
            return product.discounts.find(x => x.discountPrice === lowestDiscountPrice)
        },
        price(product){
            const quantity = product.quantity
            const originalPrice = product.price
            const hasDiscounts = product.discounts.length > 0
            const productsDiscounted = hasDiscounts ? product.discounts.reduce((partialSum, d) => {return partialSum + d.quantity}, 0) : 0
            if(productsDiscounted > 0){
                if(productsDiscounted === quantity){
                    return {
                        unit: product.discounts.reduce((partialSum, d) => {return partialSum + (d.quantity * d.discountPrice)}, 0) / quantity,
                        total: product.discounts.reduce((partialSum, d) => {return partialSum + (d.quantity * d.discountPrice)}, 0)
                    } 
                }
                if(productsDiscounted < quantity){
                    return {
                        unit: (((quantity - productsDiscounted)*originalPrice) + product.discounts.reduce((partialSum, d) => {return partialSum + (d.quantity * d.discountPrice)}, 0)) / quantity,
                        total: (((quantity - productsDiscounted)*originalPrice) + product.discounts.reduce((partialSum, d) => {return partialSum + (d.quantity * d.discountPrice)}, 0))
                    }
                }
            }
            else {
                return {
                    unit: originalPrice,
                    total: quantity*originalPrice
                }
            }
        }

    }
}
